import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { compact } from 'lodash-es';
import { ClientSummarySortDirection, ClientSummarySortField } from 'anchor-scout-common/types';
import { isClientTaxExempt } from '~/models/ClientModel';
import { formatDateLong } from '~/models/time/selectors';
import { referenceFiltersParam, referenceSortParam } from './ClientsPage.referenceFields.utils';
import { filterClients, sortClients } from './ClientsPage.utils';
export const CLIENT_COLUMN_NAMES = [
    'clientName',
    'status',
    'type',
    'contacts',
    'tax'
];
export const CLIENT_SUMMARY_COLUMN_NAMES = [
    ...CLIENT_COLUMN_NAMES,
    'lastInvoiceDate',
    'nextInvoiceDate'
];
const statusSkinByLabel = (statusTexts)=>({
        [statusTexts.active()]: 'success',
        [statusTexts.archived()]: 'default'
    });
const statusLabel = (client, statusTexts)=>client.status == null ? '' : statusTexts[client.status]();
const contactsLabel = (client, texts)=>{
    var _client_contactsCount;
    if (client.primaryContact == null) return '';
    const remainingCount = ((_client_contactsCount = client.contactsCount) !== null && _client_contactsCount !== void 0 ? _client_contactsCount : 0) - 1;
    const more = remainingCount > 0 ? texts.contactsMore({
        count: remainingCount
    }) : '';
    return "".concat(client.primaryContact.name).concat(more);
};
const taxLabel = (client, texts)=>isClientTaxExempt(client.taxSettings) ? texts.tax.exempt() : texts.tax.taxable();
export const toClientRowsOld = (param)=>{
    let { clients, texts, statusTexts } = param;
    return clients.map((client)=>{
        var _client_type, _ref;
        var _client_primaryContact;
        return {
            id: client.id,
            clientName: client.name,
            status: statusLabel(client, statusTexts),
            type: texts.typeFilter[(_client_type = client.type) !== null && _client_type !== void 0 ? _client_type : 'business'](),
            contacts: contactsLabel(client, texts),
            contactEmail: (_ref = (_client_primaryContact = client.primaryContact) === null || _client_primaryContact === void 0 ? void 0 : _client_primaryContact.email) !== null && _ref !== void 0 ? _ref : '',
            tax: taxLabel(client, texts)
        };
    });
};
const taxColumn = (texts)=>({
        type: 'text',
        name: 'tax',
        header: texts.columnHeaders.tax(),
        width: {
            initial: 160,
            min: 120
        },
        sortable: true,
        bi: {
            name: 'clients_by_tax'
        }
    });
const clientColumnsFor = (param)=>{
    let { texts, statusTexts, showTax } = param;
    return [
        {
            type: 'text',
            name: 'clientName',
            header: texts.columnHeaders.clientName(),
            width: {
                initial: 170,
                min: 170
            },
            weight: 'normal',
            sortable: true,
            bi: {
                name: 'clients_by_name'
            }
        },
        {
            type: 'badge',
            name: 'status',
            header: texts.columnHeaders.status(),
            width: {
                initial: 100,
                min: 100
            },
            useColor: (label)=>{
                var _statusSkinByLabel_label;
                return (_statusSkinByLabel_label = statusSkinByLabel(statusTexts)[label]) !== null && _statusSkinByLabel_label !== void 0 ? _statusSkinByLabel_label : 'default';
            },
            sortable: true,
            bi: {
                name: 'clients_by_status'
            }
        },
        {
            type: 'text',
            name: 'type',
            header: texts.columnHeaders.type(),
            width: {
                initial: 120,
                min: 120
            },
            sortable: true,
            bi: {
                name: 'clients_by_type'
            }
        },
        {
            type: 'text',
            name: 'contacts',
            header: texts.columnHeaders.contacts(),
            width: {
                initial: 220,
                min: 220
            },
            subtitle: (row)=>[
                    row.contactEmail
                ],
            sortable: true,
            bi: {
                name: 'clients_by_contacts'
            }
        },
        ...compact([
            showTax && taxColumn(texts)
        ])
    ];
};
export const clientColumnsOld = (args)=>clientColumnsFor(args);
export const visibleClientsOld = (param)=>{
    let { clients, search, statusFilter, typeFilter, sort } = param;
    return sortClients({
        clients: filterClients({
            clients,
            searchTerm: search,
            statusFilter,
            typeFilter
        }),
        sortKey: sort.name,
        sortDirection: sort.direction === 'asc' ? 'desc' : 'asc'
    });
};
const SORT_FIELD_BY_COLUMN = {
    clientName: ClientSummarySortField.Name,
    status: ClientSummarySortField.Status,
    type: ClientSummarySortField.ClientType,
    contacts: ClientSummarySortField.Owner,
    tax: ClientSummarySortField.Tax,
    lastInvoiceDate: ClientSummarySortField.LastInvoiceDate,
    nextInvoiceDate: ClientSummarySortField.NextInvoiceDate
};
export const CLIENT_SUMMARY_DEFAULT_SORT = {
    colIndex: 0,
    sort: 'desc'
};
export const toClientSummaryTableSort = function toClientSummaryTableSort(urlSort) {
    let sortIds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLIENT_SUMMARY_COLUMN_NAMES;
    const { colIndex, sort } = urlSort !== null && urlSort !== void 0 ? urlSort : CLIENT_SUMMARY_DEFAULT_SORT;
    return {
        name: sortIds[colIndex],
        direction: sort === 'asc' ? 'asc' : 'desc'
    };
};
export const CLIENT_SUMMARIES_PAGE_SIZE = 100;
const CLIENT_SUMMARIES_SEARCH_MAX_LENGTH = 200;
export const toClientSummariesParams = (param)=>{
    let { sort, search, statusFilter, typeFilter, page, referenceFilters = {} } = param;
    var _SORT_FIELD_BY_COLUMN_sort_name;
    const trimmedSearch = search.trim().slice(0, CLIENT_SUMMARIES_SEARCH_MAX_LENGTH);
    return _object_spread({
        page,
        limit: CLIENT_SUMMARIES_PAGE_SIZE,
        sortField: (_SORT_FIELD_BY_COLUMN_sort_name = SORT_FIELD_BY_COLUMN[sort.name]) !== null && _SORT_FIELD_BY_COLUMN_sort_name !== void 0 ? _SORT_FIELD_BY_COLUMN_sort_name : ClientSummarySortField.Name,
        sortDirection: sort.direction === 'asc' ? ClientSummarySortDirection.Desc : ClientSummarySortDirection.Asc,
        status: statusFilter,
        clientType: typeFilter
    }, trimmedSearch === '' ? {} : {
        search: trimmedSearch
    }, referenceSortParam(sort.name), referenceFiltersParam(referenceFilters));
};
const invoiceDateLabel = (date)=>date == null ? '' : formatDateLong(date.getTime());
export const toClientSummaryRows = (param)=>{
    let { clients, texts, statusTexts, referenceCells } = param;
    return clients.map((client)=>{
        var _client_type, _ref;
        var _client_primaryContact;
        return _object_spread_props(_object_spread({}, referenceCells === null || referenceCells === void 0 ? void 0 : referenceCells(client)), {
            id: client.id,
            clientName: client.name,
            status: statusLabel(client, statusTexts),
            type: texts.typeFilter[(_client_type = client.type) !== null && _client_type !== void 0 ? _client_type : 'business'](),
            contacts: contactsLabel(client, texts),
            contactEmail: (_ref = (_client_primaryContact = client.primaryContact) === null || _client_primaryContact === void 0 ? void 0 : _client_primaryContact.email) !== null && _ref !== void 0 ? _ref : '',
            tax: client.taxExempt ? texts.tax.exempt() : texts.tax.taxable(),
            lastInvoiceDate: invoiceDateLabel(client.lastInvoiceDate),
            nextInvoiceDate: invoiceDateLabel(client.nextInvoiceDate),
            client
        });
    });
};
const invoiceDateColumn = (param)=>{
    let { name, header, biName } = param;
    return {
        type: 'text',
        name,
        header,
        width: {
            initial: 140,
            min: 120
        },
        sortable: true,
        bi: {
            name: biName
        }
    };
};
export const clientSummaryColumns = (param)=>{
    let { texts, statusTexts, showTax } = param;
    return [
        ...clientColumnsFor({
            texts,
            statusTexts,
            showTax
        }),
        invoiceDateColumn({
            name: 'lastInvoiceDate',
            header: texts.columnHeaders.lastInvoice(),
            biName: 'clients_by_last_invoice'
        }),
        invoiceDateColumn({
            name: 'nextInvoiceDate',
            header: texts.columnHeaders.nextInvoice(),
            biName: 'clients_by_next_invoice'
        })
    ];
};
const sortOption = (id, label, colIndex)=>({
        id,
        label,
        defaultDirection: 'desc',
        colIndex
    });
export const clientSummarySortOptions = (texts)=>[
        sortOption('clientName', texts.columnHeaders.clientName(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('clientName')),
        sortOption('status', texts.columnHeaders.status(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('status')),
        sortOption('type', texts.columnHeaders.type(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('type')),
        sortOption('contacts', texts.columnHeaders.contacts(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('contacts')),
        sortOption('lastInvoiceDate', texts.columnHeaders.lastInvoice(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('lastInvoiceDate')),
        sortOption('nextInvoiceDate', texts.columnHeaders.nextInvoice(), CLIENT_SUMMARY_COLUMN_NAMES.indexOf('nextInvoiceDate'))
    ];
export const withClientsStatus = (clientIds, status)=>(page)=>_object_spread_props(_object_spread({}, page), {
            clients: page.clients.map((client)=>clientIds.includes(client.id) ? _object_spread_props(_object_spread({}, client), {
                    status
                }) : client)
        });
export const withSavedClient = (clientId, param)=>{
    let { name, clientType, taxSettings } = param;
    return (page)=>_object_spread_props(_object_spread({}, page), {
            clients: page.clients.map((client)=>client.id === clientId ? _object_spread(_object_spread_props(_object_spread({}, client), {
                    name,
                    type: clientType
                }), taxSettings == null ? {} : {
                    taxExempt: isClientTaxExempt(taxSettings)
                }) : client)
        });
};
export const withoutClients = (clientIds)=>(page)=>{
        const clients = page.clients.filter((client)=>!clientIds.includes(client.id));
        return {
            clients,
            totalCount: page.totalCount - (page.clients.length - clients.length)
        };
    };
